import React, { useRef, useState } from 'react'
import App from '.'
import useSideScreenHook from './Hooks/useSideScreen'
import { BrowserRouter as Router } from 'react-router-dom'
import CssBaseline from '@mui/material/CssBaseline'
import MuiThemeInjector from './Injectors/MuiThemeInjector'
import AuthInjector from './Injectors/Auth/AuthInjector'
import LanguageInjector from './Injectors/LanguageInjector'
import ApolloInjector from './Injectors/ApolloInjector'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import Loader from '../genericComponents/Loader'

const BackOffice = ({
  getRoutes,
  getLogos,
  getAvatarMenuItems,
  getMenuItems,
  authConfiguration,
  onSearch,
  getTheme,
  getAppbarOptions,
  getTranslations,
  locale
}) => {
  const darkmodeStorage = localStorage.getItem('darkmode') === 'true';
  const [darkmode, setDarkMode] = useState(darkmodeStorage);
  const toggleDarkmode = () => {
    localStorage.setItem('darkmode', !darkmode)
    setDarkMode(!darkmode)
  }

  getTheme.palette.mode = darkmodeStorage ? 'dark' : 'light';
  const theme = useRef(getTheme)
  const translations = useRef(getTranslations)
  const appLocale = useRef(locale)

  if (!theme.current || !translations.current) {
    return <Loader text="Loading theme..." />
  }
  return (
    <MuiThemeInjector theme={theme.current}>
      <AuthInjector authConfiguration={authConfiguration}>
        <ApolloInjector>
          <LanguageInjector locale={appLocale.current} translations={translations.current}>
            <CssBaseline />
            <ToastContainer
              position='bottom-right'
              autoClose={4000}
            />
            <Router>
              <App
                onSearch={onSearch}
                getLogos={getLogos}
                toggleDarkmode={toggleDarkmode}
                getAppbarOptions={getAppbarOptions}
                getAvatarMenuItems={getAvatarMenuItems}
                getRoutes={getRoutes}
                getMenuItems={getMenuItems}
              />
            </Router>
          </LanguageInjector>
        </ApolloInjector>
      </AuthInjector>
    </MuiThemeInjector>
  )
}

export default BackOffice
export const useSideScreen = useSideScreenHook
